import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getGroup,
	getGroupEndpoint,
	type QueryError,
	type GetGroupResult,
	type GetGroupRequestOptions,
} from '../getGroup';
export * from '../getGroup';

export type GetGroupQueryParams = GetGroupRequestOptions;
export type GetGroupQueryKey = [string, GetGroupQueryParams];

export const GetGroupReactQueryKey = getGroupEndpoint;

export type GetGroupQueryOptions = Omit<
	UseQueryOptions<GetGroupResult, QueryError, GetGroupResult, GetGroupQueryKey>,
	'queryKey' | 'queryFn'
> & {
	queryFn?: typeof getGroup;
};

/**
 * react-query wrapper for `getGroup`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetGroup = (
	queryKeyParams: GetGroupQueryParams,
	{queryFn = getGroup, ...options}: GetGroupQueryOptions = {},
) =>
	useQuery<GetGroupResult, QueryError, GetGroupResult, GetGroupQueryKey>({
		queryKey: [getGroupEndpoint, queryKeyParams],
		queryFn: ({queryKey, signal}) => queryFn({...queryKey[1]}, signal),
		...options,
	});

export default useReactQueryGetGroup;
